//validate alphabetic fileds
export function validateInput(event, type) {
    const input = event.target;
    const errorMessage = document.getElementById(`error-message-${input.id}`);
    var regex;
    var message;
    var isValid = true;

    if (type === 'text') {
        regex = /^[A-Za-z]+(?:\s[A-Za-z]+)*\s?$/;
        message = 'Please enter alphabets only.';
    } else if (type === 'number') {
        regex = /^[0-9]+$/;
        message = "Please enter numbers only.";
    } else if (type === 'address') {
        regex = /^[A-Za-z0-9\s\W]+$/;
        message = "Please enter valid address.";
    } else if (type === 'email') {
        regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        message = "Please enter valid email.";
    } else if (type === 'postCode') {
        regex = /^([A-Z]{1,2}[0-9]{1,2}[A-Z]?)\s?([0-9][A-Z]{2})$/i;
        message = "Please enter a valid postcode.";
    } else if (type === 'percentage') {
        regex = /^(100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{1,2})?)$/;
        message = "Please enter a valid percentage (0-100).";
    } else if (type === 'niNumber') {
        regex = /^[A-CEGHJ-PR-TW-Z]{2}[0-9]{6}[A-D]$/i;
        message = "Please enter a valid NI number.";
    } else if (type === 'accountNumber') {
        regex = /^\d{6,10}$/;
        message = "Please enter a valid account number.";
    }

    // Check if input is empty
    if (input.value.trim() === '') {
        errorMessage.textContent = "";
        input.style.border = '1px solid #ccc';
        input.setCustomValidity("");
        return;
    }
    if (input.id === 'retirementAge') {
        var age = parseInt(input.value, 10);
        if (age < 40 || age > 80) {
            message = "Please enter a retirement age between 40 and 80.";
            isValid = false
        }
    } else if (!regex.test(input.value)) {
        isValid = false
    }
    if (isValid) {
        errorMessage.textContent = "";
        input.style.border = '1px solid #ccc';
        input.setCustomValidity("");
    } else {
        input.style.border = '1px solid red';
        errorMessage.textContent = message;
        input.setCustomValidity("Invalid input");
    }
}

export function validateNumericInput(event) {
    const regex = /^[0-9]*\.?[0-9]+$/; // Regex for numeric values
    const input = event.target;
    const errorMessage = document.getElementById(`error-message-${input.id}`);

    // Allow empty field (no error when field is cleared)
    if (input.value.trim() === "") {
        errorMessage.textContent = "";
        input.style.border = '1px solid #ccc';
        input.setCustomValidity("");
        return;
    }

    // Check for valid numeric input
    if (!regex.test(input.value)) {
        input.style.border = '1px solid red';
        errorMessage.textContent = "Please enter numbers only.";
        input.setCustomValidity("Invalid input");
        return;
    }

    // Check for maximum length
    if (input.value.length > 10) {
        input.style.border = '1px solid red';
        errorMessage.textContent = "Please enter a valid amount.";
        input.setCustomValidity("Exceeds maximum length");
        return;
    }

    // Valid input case
    errorMessage.textContent = "";
    input.style.border = '1px solid #ccc';
    input.setCustomValidity("");
}

// // Format loan amount with commas
// export const formatPrice = (value) => {
//     let input = value.replace(/\D/g, '');
//     const formattedNumber = input.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
//     return formattedNumber;
// }

export function validateTwoDates(date, htmlFor) {
    const currentDate = new Date();
    const dob = new Date(date);
    const minAgeDate = new Date();
    const errorMessage = document.getElementById(`date-error-message-${htmlFor}`);
    const datePicker = document.getElementById(`${htmlFor}`);
    const wrapper = datePicker.getElementsByClassName('react-date-picker__wrapper')[0];
    errorMessage.textContent = ''
    if (htmlFor === 'dateOfBirth') {
        minAgeDate.setFullYear(currentDate.getFullYear() - 18);
        if (dob > minAgeDate) {
            errorMessage.textContent = "You must be at least 18 years old."
            if (wrapper) {
                wrapper.style.setProperty('border', '1px solid red', 'important');
            }
        } else {
            errorMessage.textContent = ''
            wrapper.style.setProperty('border', '1px solid gray', 'important');
        }
    }

    if (htmlFor === "nameChangeDate" || htmlFor === 'PassportExpiryDate') {
       
        var date1, date2, message;

        if (htmlFor === "nameChangeDate") {
            message = "Name change date must be after the DOB.";
            date1 = new Date(date);
            date2 = new Date(document.getElementById('dateOfBirth').querySelector('input').value);
        } else if (htmlFor === 'PassportExpiryDate') {
            message = "The expiry date cannot be earlier than current date. ";
            date1 = new Date(date);
            date2 = new Date();
        }

        const dateOnly1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
        const dateOnly2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

        // Compare the two dates
        if (dateOnly1.getTime() > dateOnly2.getTime()) {
            errorMessage.textContent = ""
            wrapper.style.setProperty('border', '1px solid gray', 'important');
        } else {
            errorMessage.textContent = message;
            if (wrapper) {
                wrapper.style.setProperty('border', '1px solid red', 'important');
            }
        }
    }

    return errorMessage.textContent
}

export function validateDates(previousDate, NewDate, id) {
    const errorMessage = document.getElementById(`date-error-message-${id}`);
    const previousStart = new Date(previousDate);
    const employmentStart = new Date(NewDate);
    errorMessage.textContent = '';

    if (!previousDate || !NewDate) {
        errorMessage.textContent = '';
    }
    if (previousStart >= employmentStart) {
        if(id === 'employmentStartDate' || id == "previousJobStartDate"){
            errorMessage.textContent = "Previous job start date must be before employment start date.";
        }else{
            errorMessage.textContent = "End date of loan must be after the loan start date";
        }
    }
    return errorMessage.textContent;
}